import React from 'react'
import style from './StoryTwo.module.sass'
import MarahAudio from '../media/MarahAudio.wav'
import MarahSub from '../media/MarahSub.vtt'


//use when updating markData
// const audioDuration = 705
// const getAudioPercent = (time) => {
//      return (Math.floor(Math.floor(time)/Math.floor(audioDuration)*100))
// }

const AudioPlayButton = () => {
    return (
        // buttonSVG
        <div className = {style.audioPlayerIcon}>
        <svg className = "audioPlayerIcon" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 25 30">
        <g id="Group_35" data-name="Group 35" transform="translate(-370 -1094)">
            <g id="Group_34" data-name="Group 34">
            <path id="Polygon_6" data-name="Polygon 6" d="M11,0,22,19H0Z" transform="translate(392 1098) rotate(90)"/>
            </g>
            <rect id="Rectangle_64" data-name="Rectangle 64" width="25" height="30" transform="translate(370 1094)" fill="none"/>
        </g>
        </svg>
        </div>
    )
}
const AudioPauseButton = () => {
    return (
        // buttonSVG
        <div className = {style.audioPlayerIcon}>
        <svg className = "audioPlayerIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 30">
            <g id="Group_30" data-name="Group 30" transform="translate(-421 -1110)">
            <rect id="Rectangle_50" data-name="Rectangle 50" width="25" height="30" transform="translate(421 1110)" fill="none"/>
            <g id="Group_29" data-name="Group 29" transform="translate(10 -96)">
                <rect id="Rectangle_48" data-name="Rectangle 48" width="4.441" height="22.328" transform="translate(416 1210)"/>
                <rect id="Rectangle_49" data-name="Rectangle 49" width="4.441" height="22.328" transform="translate(426 1210)"/>
            </g>
            </g>
        </svg>
        </div>

    )
}

//data for audio timeline markers
const markData = [
        {percent: '1',
        time: 11,
        question: 'What are the three words that jump into your mind when you think about "period"?',
        },
        {percent: '3',
        time: 22,
        question: 'How does your culture react to period, in comparison to the UK?',
        },
        {percent: '14',
        time: 104,
        question: 'Do you remember when you first got your period?',
        },
        {percent: '30',
        time: 212,
        question: 'How has your experience been dealing with your period?',
        },
        {percent: '43',
        time: 307,
        question: 'What do you think about period shame?',
        },
        {percent: '54',
        time: 382,
        question: 'Could you share a period story?',
        },
        {percent: '57',
        time: 402,
        question: 'What is your experience talking about period?',
        },
        {percent: '70',
        time: 494,
        question: 'Do you think period stigma exists?',
        },
        {percent: '81',
        time: 574,
        question: 'How do you feel about religious restrictions on menstruating women?',
        },
        {percent: '93',
        time: 658,
        question: 'What is the most absurd rumour you heard about period?',
        },
        {percent: '96',
        time: 680,
        question: 'What do you think the solution is to smash period stigma?',
        },
        {percent: '99',
        time: 702,
        question: "If you can magically change one thing about people's beliefs about period, what would it be?",
        },
]

//show question text when marker is clicked & when time matches
const showQuestion = (i) => {
    const questionText= document.querySelector(`.questionText`);
    questionText.innerHTML = `${markData[i].question}`;
    const story_audio = document.getElementById("marah_audio");
    story_audio.play();
}

//get time in format 00:01
function getTime(time) {
    if(!isNaN(time)) {
      return Math.floor(time / 60) + ':' + ('0' + Math.floor(time % 60)).slice(-2)
    }
  }

class StoryTwo extends React.Component {
    constructor(props){
        super(props);
        this.marahAudio = React.createRef();
        this.soundEffect = React.createRef();
        this.mark = React.createRef();
        this.transcriptContainer = React.createRef();
        this.state = {
            // playAudio: false,
            // muted: false,
        };
        this.handleAudio = () => {
            if (this.marahAudio.current.paused){
                this.marahAudio.current.play();
            } else { 
                this.marahAudio.current.pause();
            }
        };
        this.handleMute = () => {
            if (this.marahAudio.current.muted){
                this.marahAudio.current.muted = false;
            } else { 
                this.marahAudio.current.muted = true;
            }
        }
    }

//get live audio time update
    componentDidMount() {

            this.marahAudio.current.addEventListener("timeupdate", e => {
              this.setState({
                currentTime: e.target.currentTime,
                duration: e.target.duration,
                audioFinished: e.target.ended,
                audioPaused: e.target.paused,
              });
          
            });

            this.marahAudio.current.addEventListener("loadstart", e => {
                this.setState({
                  audioPaused: e.target.paused,
                });
            
              });
   
          }

//get subtitle to show with custom style
    triggerDisplayTranscript() {
        //get audio file & sub container
        const my_test_audio = document.getElementById("marah_audio")
        const my_transcript_container= document.getElementById("transcript_container")
        
        //get sub track & cues;  hide sub
        const tracks = my_test_audio.textTracks[0];
        const cues = tracks.cues;
        tracks.mode = 'hidden';

        // console.log(cues)
        // console.log(cues[0].text)
        // console.log(cues[0].onenter)

        //replace innerHTML
        const replaceText = (text) => {
            my_transcript_container.innerHTML = text
        };

        //with sub text
        const cueEnter = function () {
           replaceText(this.text);
        };

        //get timings of sub text with onenter
        const displayTranscript = (e) => {
            let i
            for (let i = 0; i < cues.length; i++){
                let cue = cues[i];
                cue.onenter = cueEnter
            }
        }

        displayTranscript();
      
    
    }
        render(){  
            let currentTimeNumber =  getTime(this.state.currentTime) || '0:00' 
            let durationNumber = getTime(this.state.duration) || '11:45' 
            
            //get current playing percentage
            const getPercentage = (currentTime, duration) => {
                return (Math.floor(currentTime)/Math.floor(duration) * 100)
            }

            let percentage = getPercentage(this.state.currentTime, this.state.duration)

            return(
                <>
                <div className =  {`${style.storyTwo} main`}>

                    {/* Asset */}
                    <video src = {MarahAudio} onPlay = {this.triggerDisplayTranscript} id ="marah_audio" className = {style.videoFile} ref = {this.marahAudio} >
                    <track src= {MarahSub} kind="captions" srcLang="en" label="English" default></track>
                    </video>
                    
                    {/* Transcript Container */}
                    <div className = {style.transcriptContainer} >
                        <div className = {`${style.transcript} transcript`}>
                            <div className = {`${style.prompt} eTwoText questionText`}></div>
                            <div id = "transcript_container" className = {`${style.transcriptText} transcriptText`}>Click play to listen to Marah's story.</div>
                            <div className = {style.audioAni}>
                            <div className = {`${!this.state.audioPaused && !this.state.audioFinished ? style.outerCircleAni : style.outerCircle} outerCircle`}>
                                <div className = {`${style.innerCircle} innerCircle`}></div>
                            </div>
                            </div>
                        </div>
                    </div>

                    {/* audio controls */}
                    <div className = {`${style.audioTimelineContainer} audioTimelineContainer`}>
                        {/* play/pause button */}
                             <div className = {style.audioIconContainer} onClick = {this.handleAudio} >
                                {this.state.audioPaused || this.state.audioFinished ?
                                        <AudioPlayButton />
                                        :
                                        <AudioPauseButton /> }    
                            </div>
                            <div  className = {`${style.audioIconContainer} titleThreeText`}>
                                 {currentTimeNumber}/{durationNumber}
                        </div>
                         

                        <div className = {style.progressContainer}> 

                            <div className = {style.markContainer}>      
                                {/* markers */}
                                {markData.map((mark, i) => {
                                    if (Math.floor(this.state.currentTime) === mark.time){
                                        showQuestion(i)
                                    }
                                    return(
                                        <div key = {i} onMouseOver = {this.props.playCorrect} className ={`mark ${style.mark}`} onClick = {()=> {this.marahAudio.current.currentTime = mark.time; showQuestion(i)}} style = {{marginLeft: `${mark.percent}%`}}>
                                            <span className = {`${style.tooltip} tooltip`}>{markData[i].question}</span>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                      
                            <div className = {`${style.progressBar} progressBar`}>
                                <div className = {`${style.filler} filler`} style = {{width: `${percentage}%`}}></div>
                            </div>
                        </div>
                    </div>                  
                </div>
                </>
            )
        }
}

  
export default StoryTwo

    // componentWillUnmount() {
    //         this.marahAudio.removeEventListener("timeupdate", () => {});
    //       }